<template>
  <div>
    <div class="msg-push-info">
      <div class="title">基本信息</div>
      <div class="flex">
        <div class="img mr10">
          <el-image style="width: 100%" :src="msgInfo.img" fit="fit"></el-image>
        </div>
        <div class="flex-1 flex flex-column flex-center">
          <div class="flex msg-info">
            <div class="flex-1" style="font-size: 16px; font-weight: bold" v-if="row.planType != 'tagGroup'">
              计划名称：{{ row.couponSendName }}
            </div>
            <div class="flex-1" style="font-size: 16px; font-weight: bold" v-if="row.planType === 'tagGroup'">
              计划名称：{{ row.planName }}
            </div>
            <div class="flex-1 flex">
              计划状态：
              <div v-if="row.planStatus === 'notStart'" class="gray">
                未开始
              </div>
              <div v-else-if="row.planStatus === 'running'" class="success">
                进行中
              </div>
              <div v-else-if="row.planStatus === 'end'" class="gray">
                已结束
              </div>
              <div v-else-if="row.planStatus === 'errorStop'" class="danger">
                异常暂停
              </div>
              <div v-else-if="row.planStatus === 'stop'" class="orange">
                暂停
              </div>
            </div>
            <div class="flex-1">计划方式：长期计划</div>
            <div class="flex-1">
              计划时间： {{ row.planStartDate }}至{{ row.planEndDate }}
            </div>
          </div>
          <div class="flex mt10 msg-info">
            <div v-if="row.planType === 'tagGroup' && tagGroupName">目标人群：{{tagGroupName}}</div>
            <div v-else class="flex-1">目标人群：{{ row.planRangeName }}</div>
            <div class="flex-5 ml20">权益礼包：{{ row.couponSendName || "无" }}</div>
            <!-- <div class="flex-1"></div>

            <div class="flex-1"></div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="msg-push-info" style="padding-bottom: 50px">
      <div class="title">运营数据</div>
      <div class="flex flex-end">
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择开始时间"
          end-placeholder="请选择结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
          @change="createTimeArryChange"
          :picker-options="pickerOptions"
        ></el-date-picker>
      </div>

      <div class="flex flex-center mt20">
        <div
          class="flex-1 flex purchase-data p10 pointer"
          :class="{ mr20: i < list.length - 1 }"
          v-for="(v, i) in list"
          :key="i"
          @click="gogogo(v)"
        >
          <div class="hm-icon mr10">
            <span class="hmicon" :class="v.icon"></span>
          </div>
          <div class="flex-1">
            <el-tooltip
              class="tooltip"
              effect="light"
              :content="v.tip"
              placement="top"
            >
              <span class="purchase-name mt10 flex item-center">
                {{ v.name }}

                <i
                  class="el-icon-question"
                  style="font-size: 18px; color: #ddd"
                ></i>
              </span>
            </el-tooltip>
            <div class="mt10 flex flex-between item-center">
              <div class="purchase-val">
                {{ i === 4 ? "￥" + toPriceNum(v.val.toFixed(2)) : v.val }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="funnel mt20 flex flex-column flex-center">
        <div
          class="funnel-row flex-1 flex flex-column flex-center ml20"
          v-for="(v, i) in h"
          :key="i"
        >
          <div class="flex">{{ v.name }}</div>
          <div>{{ v.val }}</div>
          <div class="tit">{{ v.name }}</div>
        </div>
        <div class="cover-notice">
          转化率
          <div>{{ coverNumRatio }}</div>
        </div>
        <div class="cover-access">
          转化率
          <div>{{ noticeNumVisRatio }}</div>
        </div>
        <div class="notice-purchase">
          转化率
          <div>{{ noticeNumRatio }}</div>
        </div>
        <!-- <div class="cover-purchase">
          转化率
          <div>{{ payNumRatio }}</div>
        </div> -->
      </div>
    </div>
    <div class="msg-push-info">
      <div class="title">
        计划消息推送历史
        <span style="font-size: 14px" class="gray"
          >该计划已运行
          <span class="success">{{ planExecRecordModelList.length }}</span>
          次</span
        >
      </div>
      <div>
        <el-table
          stripe
          ref="btable"
          :data="planExecRecordModelList"
          style="width: 100%"
          id="table"
          size="small"
          max-height="300"
          empty-text="暂无推送历史，请明日再查看效果"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="sendTitle"
            label="推送标题"
            width="300"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="triggerTime"
            label="推送时间"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="noticeNum"
            label="通知人数"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="visitNum"
            label="访问人数"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="proportion"
            label="复购率"
          >
            <template slot-scope="scope">
              <div class="flex item-center">
                {{ scope.row.proportion }}
                <span class="success mr10">表现良好</span>
                <span class="hmicon icon-piliangqueren success"></span>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column
            header-align="left"
            align="left"
            prop="spuName"
            label="状态"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.recordStatus === 'success'">
                <span class="success">已完成</span>
                <!-- <template v-if="scope.row.isHaveErrorMsg">
                  <span
                    style="font-size: 14px"
                    class="hmicon icon-tishi1 danger ml10"
                  ></span>
                  <span class="danger"> 有失败消息</span>
                  <el-button size="small" class="blue" type="text"
                    >查看详情</el-button
                  >
                </template> -->
              </div>
              <div v-if="scope.row.recordStatus === 'errorStop'" class="danger">
                异常暂停
                <span style="font-size: 14px" class="hmicon icon-tishi1"></span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            header-align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="singelUser(scope.row)"
                >详细用户</el-button
              >
              <el-divider direction="vertical"></el-divider>
              <el-button
                size="small"
                class="blue"
                type="text"
                @click="singelMsg(scope.row)"
                >单次推送统计</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        disabledDate: time => {
          return (
            time.getTime() < new Date(this.row.planStartDate).getTime() - 8.64e7
          );
        }
      },
      planExecRecordModelList: [],
      h: [
        {
          name: "覆盖人数",
          val: 0
        },
        {
          name: "通知人数",
          val: 0
        },
        {
          name: "访问人数",
          val: 0
        }
        // {
        //   name: "付款人数",
        //   val: 0
        // }
      ],
      list: [
        {
          icon: "icon-fugairenshu",
          name: "覆盖人数(人）",
          val: 0,
          tip: "覆盖人数",
          pathName: "SchemeUserDetails",
          queryStatus: "cover"
        },
        {
          icon: "icon-tongzhirenshu1",
          name: "通知人数(人）",
          val: 0,
          tip: "通知人数",
          pathName: "SchemeUserDetails",
          queryStatus: "notice"
        },
        {
          icon: "icon-fangwenrenshu",
          name: "访问人数(人）",
          val: 0,
          tip: "访问人数(人）",
          pathName: "SchemeUserDetails",
          queryStatus: "visit"
        }
        // {
        //   icon: "icon-fukuanrenshu",
        //   name: "付款人数(人）",
        //   val: 0,
        //   tip: "付款人数(人）",
        //   pathName: "SchemeUserDetails",
        //   queryStatus: "pay"
        // }
        // {
        //   icon: "icon-fukuanjine",
        //   name: "付款金额(元）",
        //   val: 0,
        //   tip: "付款金额(元）",
        //   pathName: "SchemeUserDetails",
        //   queryStatus: "pay"
        // }
      ],
      createTimeArry: [],
      row: JSON.parse(this.$route.query.row),
      msgInfo: {
        img: "https://imgcdn.hemiao100.com/ThemePictures/defaultgood.png",
        goodsName: "惠氏三段新西兰进口羊奶粉 800g",
        time: "2020-12-04 12:00:00"
      },
      coverNumRatio: "0%",
      noticeNumVisRatio: "0%",
      noticeNumRatio: "0%",
      payNumRatio: "0%",
      tagGroupName: '',
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.createTimeArry = [
      this.row.planStartDate + " 00:00:00",
      this.row.planEndDate + " 23:59:59"
    ];

    this.getRepurchasePlanCensusNum();
    this.getRepurchasePlanCensus();
  },
  methods: {
    gogogo(v) {
      this.$router.push({
        name: v.pathName,
        query: {
          queryStatus: v.queryStatus,
          id: this.row.id
        }
      });
    },
    singelUser(row) {
      this.$router.push({
        name: "SingleUserDetails",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    singelMsg(row) {
      this.$router.push({
        name: "SingleMessageStatistics",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    async getRepurchasePlanCensus() {
      const { code, result } = await this.$store.dispatch(
        "getRepurchasePlanCensus",
        {
          id: this.row.id
        }
      );
      if (code === "0") {
        const { planExecRecordModelList } = result;
        planExecRecordModelList.forEach(v => {
          v.proportion = v.noticeNum
            ? ((v.payNum / v.noticeNum) * 100).toFixed(2) + "%"
            : "0%";
        });
        this.planExecRecordModelList = planExecRecordModelList;
        this.tagGroupName = result.planInfoModel.tagGroupName;
      }
    },
    createTimeArryChange() {
      this.getRepurchasePlanCensusNum();
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async getRepurchasePlanCensusNum() {
      const params = {
        id: this.row.id,
        queryStartTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[0]
          : "",
        queryEndTime: this.isArray(this.createTimeArry)
          ? this.createTimeArry[1]
          : ""
      };
      const { code, result } = await this.$store.dispatch(
        "getRepurchasePlanCensusNum",
        params
      );
      if (code === "0") {
        const { coverNum, noticeNum, payNum, payPrice, visitNum } = result;
        this.list[0].val = coverNum;
        this.list[1].val = noticeNum;
        this.list[2].val = visitNum;
        // this.list[3].val = payNum;
        // this.list[4].val = payPrice;
        this.h[0].val = coverNum;
        this.h[1].val = noticeNum;
        this.h[2].val = visitNum;
        // this.h[3].val = payNum;
        if (coverNum && noticeNum) {
          this.coverNumRatio = ((noticeNum / coverNum) * 100).toFixed(2) + "%";
        } else {
          this.coverNumRatio = "0%";
        }
        if (noticeNum && visitNum) {
          this.noticeNumVisRatio =
            ((visitNum / noticeNum) * 100).toFixed(2) + "%";
        } else {
          this.noticeNumVisRatio = "0%";
        }
        if (visitNum && payNum) {
          this.noticeNumRatio = ((payNum / visitNum) * 100).toFixed(2) + "%";
        } else {
          this.noticeNumRatio = "0%";
        }
        // if (payNum && coverNum) {
        //   this.payNumRatio = ((payNum / coverNum) * 100).toFixed(2) + "%";
        // } else {
        //   this.payNumRatio = "0%";
        // }
      }
    },
    toPriceNum(num) {
      if (isNaN(num)) {
        num = 0;
      }
      return (
        num &&
        num.toString().replace(/\d+/, function(s) {
          return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
        })
      );
    }
  }
};
</script>
<style lang='scss' scoped>
.msg-push-info {
  background: #fff;
  margin-bottom: 10px;
  padding: 20px;
  .img {
    width: 66px;
  }
}
.title {
  color: #222222;
  font-weight: bold;
  margin-bottom: 18px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 4px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.msg-info {
  > div {
    font-size: 14px;
    color: #222;
  }
}
.purchase-data {
  box-shadow: 0px 0px 18px 0px rgba(221, 221, 221, 0.39);
  border-radius: 6px;
  .hm-icon {
    width: 66px;
    height: 66px;
    border-radius: 50%;
    text-align: center;
    line-height: 66px;
    background: #feeef5;
    .hmicon {
      font-size: 25px;
      color: #e50065;
    }
  }
  .purchase-name {
    color: #222222;
    font-size: 14px;
  }
  .purchase-val {
    font-size: 22px;
    font-weight: bold;
  }
}
.funnel {
  background-image: url("https://imgcdn.hemiao100.com/ThemePictures/%E6%BC%8F%E6%96%97%E5%9B%BE%402x.png");
  height: 340px;
  background-size: 98% 100%;
  position: relative;
  background-repeat: no-repeat;
  .funnel-row {
    position: relative;
    line-height: 24px;
    .tit {
      position: absolute;
      right: 29%;
      color: #fff;
    }
  }
  .cover-notice {
    position: absolute;
    top: 22%;
    right: 6%;
    font-size: 14px;
  }
  .cover-access {
    position: absolute;
    top: 60%;
    right: 8%;
    font-size: 14px;
  }
  .notice-purchase {
    position: absolute;
    bottom: 45%;
    font-size: 14px;
    right: 1%;
  }
}
// .funnel {
//   background-image: url("https://imgcdn.hemiao100.com/ThemePictures/%E6%BC%8F%E6%96%97%E5%9B%BE%402x444.png");
//   height: 380px;
//   background-size: 98% 100%;
//   position: relative;
//   background-repeat: no-repeat;
//   .funnel-row {
//     position: relative;
//     line-height: 24px;
//     .tit {
//       position: absolute;
//       right: 29%;
//       color: #fff;
//     }
//   }
//   .cover-notice {
//     position: absolute;
//     top: 16%;
//     right: 6%;
//     font-size: 14px;
//   }
//   .cover-access {
//     position: absolute;
//     top: 45%;
//     right: 8%;
//     font-size: 14px;
//   }
//   .notice-purchase {
//     position: absolute;
//     bottom: 19%;
//     right: 10%;
//     font-size: 14px;
//   }
//   .cover-purchase {
//     position: absolute;
//     bottom: 40%;
//     font-size: 14px;
//     right: 2%;
//   }
// }
</style>
